import React, { Component, Suspense } from "react";
const Header = React.lazy(() => import("../layout/header"))
const Footer = React.lazy(() => import("../layout/admin_footer"))
function Dashboard() {
  if (localStorage.getItem("isLogedIn") === "null" || localStorage.getItem("isLogedIn") === null) {
    window.location.href = '/cms-login'
  }
  return (
    <div className='admin_dashboard_wrapr'>
      <Suspense fallback={<div></div>}>
        <Header/>
        <div className="container dashbrd_listheight">
          <div className="breadcrumbs breadcrumbs_dashboard">
            <ul>
              <li>
                <a href="/dashboard" class="breadcrumbLink">
                  Dashboard
                </a>
              </li>
              <div class="breadcrumbarrow-right" />
              <li>View Reports</li>
            </ul>
          </div>
          <div className="admin_dashboard_outer">
            <a href="/centerList" className="dashboard_menu">Center List</a>
            <a href="/contact_report" className="dashboard_menu">Contact Report</a>
          </div>
        </div>
        <Footer />
      </Suspense>
    </div>
  )
}
export default Dashboard